import * as moment from 'moment';

import { Project } from './project.model';

// tslint:disable:max-line-length
export const projects: Array<Project> = [
    {
        banner: 'cdc/project-banner.jpg',
        buildingBlocks: [
            {
                name: 'live-project',
                context: {
                    url: 'https://forcit.be',
                    content: `
                        <strong>Tim Saey,</strong> owner of Car Detailing Corner, spent years applying his knowledge of fine-tuning cars
                        at BMW Verstraeten. After-hours, he continued his love for vehicles by detailing all types of
                        vehicles. Having spent years improving his skills and knowledge of vehicles at the dealership,
                        combined with constant research into finding top quality detailing products and partners,
                        gave him the tools to turn his passion into his main profession.  These skills and knowledge
                        in combination with the tangible market need for high-level detailing finalised the decision
                        to start providing his value full-time with Car Detailing Corner.  Which leads us to defining
                        the…`,
                },
            },
            {
                name: 'image',
                context: {
                    image: '/cdc/cdc.png',
                    maxHeight: 'auto',
                },
            },
            {
                name: 'spacer',
                context: {
                    height: 10,
                },
            },
            {
                name: 'heading',
                context: {
                    content: 'Define the <strong>Problem.</strong>',
                },
            },
            {
                name: 'spacer',
                context: {
                    height: 2,
                },
            },
            {
                name: 'paragraph',
                context: {
                    content: `
                Together with Car Detailing Corner we quickly emphasized that the value they offer is a very visual one.
                After all you detail a car because the owner want to show his possession in its most pristine condition.
                From the start it was apparent that we needed to heavily incorporate visual elements to convey the
                message.  Furthermore the company needed help defining the different services they offer through
                content.`,
                },
            },
            {
                name: 'paragraph',
                context: {
                    content: `
                This website isn’t just a means to communicate what Car Detailing Corner can do as well as showcase its
                work. We want to create an environment that makes communicating between company and stakeholders easier
                so the company can spend its time on creating value, not processing information. That’s why we took a
                scrutinous look at the administrative tasks and lead processing that would occur and which of these
                could be automated.  We quickly came to the conclusion that we needed to offer the lead some
                information (pricing estimation), which leads to converting them into a potential customer through
                an appointment system.`,
                },
            },
            {
                name: 'spacer',
                context: {
                    height: 10,
                },
            },
            {
                name: 'image-spotlight',
                context: {
                    heading: 'Show the <strong>Results.</strong>',
                    content: `
                  Together with Car Detailing Corner, we worked for three months to define the communication channel,
                  write, format and edit the content that is and shall be added in the future. We built a web channel,
                  supported by a CMS that was focused on four main problems or opportunities for our client which we
                  believe could provide the maximum effectiveness.`,
                    bgImage: 'cdc/banner.png',
                    image: 'cdc/mockup1.png',
                },
            },
            {
                name: 'spacer',
                context: {
                    height: 10,
                },
            },
            {
                name: 'image-paragraph',
                context: {
                    image: {
                        image: 'cdc/mockup2.png',
                        maxWidth: '300px',
                    },
                    blocks: [{
                        name: 'paragraph',
                        context: {
                            content: `<ul>
                            <li>
                            Communicate which services Car Detailing Corner offers and what value
                            this business offering has for potential clients.
                            </li>
                            <li>
                            Answer a need from our client’s customers to keep an accurate log of the projects so they
                            can showcase their cars
                            </li>
                            <li>
                            Answer a need from our client’s customers to showcase each project, whilst maintaining
                            an intuitive user experience through filters and search.
                            </li>
                            <li>Reduce the manual work for Car Detailing Corner to process potential
                            customers and automatically plan meetings.
                            </li>`,
                        },
                    }],
                },
            },
        ],
        description: `
            Car Detailing Corner is the specialist to consult if you believe your car deserves that
            showroom look. Do you think your new or second-hand vehicle could use some help to
            truly make it shine, then this is the company you call!`,
        endDate: moment('2017-08-25'),
        image: 'cdc/project-banner.jpg',
        name: 'Car Detailing Corner',
        slug: 'cdc',
        startDate: moment('2017-08-23'),
        title: 'Detailing to <strong>digital.</strong>',
    },
];
// tslint:enable:max-line-length



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/projects.ts